export default __webpack_public_path__ + "static/media/gallery_11.4ba844bf.jpg";